import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BackendService {

    constructor(private http: HttpService) {
    }

    public get(url: string): Observable<any> {
        console.log("backend-service-get", url);
        return this.http.get(url)
            .pipe(map(response => response));
    }

    public post(url: string, data: any): Observable<any> {
        console.log("backend-service-post", url, data);
        return this.http.post(url, data)
            .pipe(map(response => response));
    }

    /**
     * Servicio para realizar peticiones POST de archivos
     *
     * @param url --> Url de invocación
     * @param data --> Datos para la solicitud
     */
    public postFile(url: string, data: any): Observable<any> {
        console.log("backend-service-postFile", url, data);
        return this.http.postFile(url, data)
            .pipe(
                (map(response => response))
            );
    }

    public put(url: string, data: any): Observable<any> {
        console.log("backend-service-put", url, data);
        return this.http.put(url, data)
            .pipe(map(response => response));
    }

    public patch(url: string, data: any): Observable<any> {
        console.log("backend-service-patch", url, data);
        return this.http.patch(url, data)
            .pipe(map(response => response));
    }

    public getReport(url: string): Observable<Blob> {
        console.log("backend-service-getReport", url);
        return this.http.getReport(url)
            .pipe(map(response => response));
    }
    public delete(url: string): Observable<any> {
        console.log("backend-service-delete", url);
        return this.http.delete(url).pipe(map(response => response));
    }
}
